import { render, staticRenderFns } from "./MMP_DPR_SerialNumberChange.vue?vue&type=template&id=9b8e1432&scoped=true&"
import script from "./MMP_DPR_SerialNumberChange.vue?vue&type=script&lang=js&"
export * from "./MMP_DPR_SerialNumberChange.vue?vue&type=script&lang=js&"
import style0 from "./MMP_DPR_SerialNumberChange.vue?vue&type=style&index=0&id=9b8e1432&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8e1432",
  null
  
)

export default component.exports